import * as React from "react";
import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "text line" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M12 3.5H8C6.114 3.5 5.172 3.5 4.586 4.086C4 4.672 4 5.614 4 7.5V8.45M12 3.5H16C17.886 3.5 18.828 3.5 19.414 4.086C20 4.672 20 5.614 20 7.5V8.45M12 3.5V8.5M12 21.5V12.5M7 21.5H17", stroke: "#1764C0", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgText);
export { ForwardRef as ReactComponent };
